export default function round (value) {
  if (!Number.isFinite(value)) {
    return value;
  }

  return value.toFixed(2);
};
